import { Role } from "@/api/enums/Role";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/atoms/Form";
import { RadioGroup, RadioGroupItem } from "@/components/atoms/RadioGroup";
import { useFormContext } from "react-hook-form";

interface PayerRadioProps {
  name: string;
  companyName: string;
}

const PayerRadio = ({ name, companyName }: PayerRadioProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="w-full">
          <FormLabel>Qui a payé ?</FormLabel>
          <FormControl>
            <RadioGroup
              value={field.value}
              name={field.name}
              onValueChange={field.onChange}
              className="flex flex-col gap-2"
            >
              {[
                { value: Role.COMPANY, label: companyName },
                { value: Role.CANDIDATE, label: "Le candidat" },
              ].map(({ label, value }) => (
                <FormItem className="flex items-center" key={value}>
                  <FormControl>
                    <div className="flex items-center">
                      <RadioGroupItem
                        id={`${field.name}-${value}`}
                        value={value}
                        className="flex items-center justify-center"
                      />
                      <FormLabel htmlFor={`${field.name}-${value}`}>
                        {label}
                      </FormLabel>
                    </div>
                  </FormControl>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default PayerRadio;
